module.exports = __webpack_public_path__ + "static/img/R-C.1fea3c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/R-C.png
// module id = zjSk
// module chunks = 0